module.exports = __webpack_public_path__ + "img/chat-translate.e05315e0.png";